import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { Table, Container, Button, Modal, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../../components/navbar/navbar';
import apinode from '../../services/apinode';
import { toast } from 'react-toastify'

const ImportExcel = () => {
    const [data, setData] = useState([]);
    const [filteredPayload, setFilteredPayload] = useState([]);
    const [stockUpdatePayload, setStockUpdatePayload] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [modalType, setModalType] = useState('');

    const smallFontStyle = {
        fontSize: '12px',
        padding: '5px'
    };

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            const filteredData = sheetData.filter(row => {
                const cellValue = String(row[0]);
                return !cellValue.startsWith('Totais');
            });

            setData(filteredData);
        };

        reader.readAsBinaryString(file);
    };

    const prepareDataForSending = () => {
        const payload = data.slice(1).map(row => {
            const entradaQtd = parseFloat(row[3]?.replace(/\./g, '').replace(',', '.'));
            const quantidade = parseFloat(row[7]?.replace(/\./g, '').replace(',', '.'));
            const valorDinheiro = parseFloat(row[4]?.replace(/\./g, '').replace(',', '.'));
            const unitario = valorDinheiro / entradaQtd;

            return {
                codigo: row[0],
                qtd: row[3],
                entradas: parseFloat(quantidade),
                valorEntradas: valorDinheiro,
                valorUni: unitario
            };
        });

        const filteredPayload = payload.filter(item => item.entradas !== undefined && item.valorEntradas !== undefined && item.valorUni > 0);

        setFilteredPayload(filteredPayload);
        setModalType('sendData');
        setShowModal(true);
    };

    const prepareStockUpdateData = () => {
        const payload = data.slice(1).map(row => {
            const entradaQtd = parseFloat(row[3]?.replace(/\./g, '').replace(',', '.'));
            const quantidade = parseFloat(row[7]?.replace(/\./g, '').replace(',', '.'));
            const valorDinheiro = parseFloat(row[4]?.replace(/\./g, '').replace(',', '.'));

            return {
                codigo: row[0],
                entradas: parseFloat(quantidade),
                valorEntradas: valorDinheiro
            };
        });

        const stockUpdatePayload = payload.filter(item => item.entradas !== undefined && item.valorEntradas !== undefined && item.entradas > 0);

        setStockUpdatePayload(stockUpdatePayload);
        setModalType('updateStock');
        setShowModal(true);
    };

    const handleSendData = async () => {
        setLoading(true);
        try {
            const response = await apinode.put(`/estoque/saldoestoque/${localStorage.idconta}`, filteredPayload);
            console.log('Dados enviados com sucesso:', response);
            toast.success('Dados enviados com sucesso!')
        } catch (error) {
            console.error('Erro ao enviar dados:', error);
            toast.error('Ocorreu um erro ao enviar os dados:', error)
        } finally {
            setLoading(false);
            setShowModal(false);
        }
    };

    const handleUpdateStock = async () => {
        setLoading(true);
        try {

            console.log(stockUpdatePayload)
            const response = await apinode.put(`/estoque/atualizarestoque/${localStorage.idconta}`, stockUpdatePayload);
            console.log('Estoque atualizado com sucesso:', response);
            toast.success('Estoque atualizado com sucesso!')
        } catch (error) {
            console.error('Erro ao atualizar estoque:', error);
            toast.error('Ocorreu um erro ao atualizar o estoque:', error)
        } finally {
            setLoading(false);
            setShowModal(false);
        }
    };

    const handleModalConfirm = () => {
        if (modalType === 'sendData') {
            handleSendData();
        } else if (modalType === 'updateStock') {
            handleUpdateStock();
        }
    };

    return (
        <>
            <Navbar />
            <Container className='mt-page'>
                <h1>Importar Dados do Excel</h1>
                <input type="file" onChange={handleFileUpload} accept=".xls,.xlsx" />
                {data.length > 0 && (
                    <div>
                        <div className="table-responsive">
                            <Table striped bordered hover className="table-sm">
                                <thead>
                                    <tr>
                                        {data[0].map((header, index) => (
                                            <th key={index} style={smallFontStyle}>{header}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.slice(1).map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} style={smallFontStyle}>{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                        <Button onClick={prepareDataForSending} className="mb-3">Preparar Dados para Envio</Button>
                        <Button onClick={prepareStockUpdateData} className="mb-3">Atualizar Estoque</Button>
                    </div>
                )}
            </Container>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmação de {modalType === 'sendData' ? 'Envio' : 'Atualização de Estoque'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalType === 'sendData' ? (
                        <>
                            <p>Os seguintes SKUs serão atualizados:</p>
                            <ul>
                                {filteredPayload.map(item => (
                                    <li key={item.codigo}>{item.codigo} {formatCurrency(item.valorUni)}</li>
                                ))}
                            </ul>
                            <p>Deseja continuar?</p>
                        </>
                    ) : (
                        <>
                            <p>Os seguintes SKUs terão seu estoque atualizado:</p>
                            <ul>
                                {stockUpdatePayload.map(item => (
                                    <li key={item.codigo}>{item.codigo} {item.entradas}</li>
                                ))}
                            </ul>
                            <p>Deseja continuar?</p>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleModalConfirm} disabled={loading}>
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />{' '}
                                {modalType === 'sendData' ? 'Enviando...' : 'Atualizando...'}
                            </>
                        ) : (
                            modalType === 'sendData' ? 'Confirmar Envio de dados' : 'Confirmar Atualização'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ImportExcel;
